import { Component } from '@angular/core';
import { Storage } from '@ionic/storage'
import { UtilsProvider } from '../../providers/utils/utils';
import { ProductosProvider } from '../../providers/productos/productos';
import { AuthService } from '../../providers/auth-service';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { PushProvider } from '../../providers/push/push';
import { CompaniasProvider } from '../../providers/companias/companias';

@Component({
  selector: 'productos-campos-adicionales-cambiar-valor',
  templateUrl: 'productos-campos-adicionales-cambiar-valor.html',
  providers:[
   UtilsProvider,ProductosProvider, AuthService,PushProvider,CompaniasProvider,
  ]
})
export class ProductosCamposAdicionalesCambiarValorComponent {

  tags = ['Ionic', 'Angular', 'TypeScript'];

  listaGruposProductos = []
  valoresCliente: string = 'Buscar Cliente';
  listaProductos = []
  listaClientes = [];
  filtrogruposProductosId
  loader
  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  realizandoUnaVenta: boolean = false
  clienteId = []
  clienteGenerico
  listaMuestra = []
  valormesa = 0
  datosAdicionales
  listaDenominaciones = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerCodigoBarra;
  timerVal;
  public picture;
  public codigoBarra:any =""
  cantidadRealCodigoBarra:number = 0
  public formState: string = 'collapsed'
  public formStateDescripcion: string = 'collapsed'
  public formStatebool:boolean= false
  public formStateboolDescripcion:boolean= false
  codigoProducto
  nombreProducto
  valorVenta
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId
  productoId
  listaGrupos
  CheckCredito:boolean = false
  CheckImprimir:boolean = false
  datosCredito = []
  ventasDiarias = []
  valorImpuestosIndividual:number=0
  valorProductoIndividual :number=0
  allItems: any;
  buscar: any = "";
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  listaABC = []
  imagenImprimir:boolean = false
  token:string
  element: HTMLElement;
  blue:string=''
  CheckPorcentajeServicio:boolean = false
  valorTotalServicio:number=0
  porcentajeServicioValor:string="N"
  porcentajeServicioValorPedidosSalon:string="N"
  cambiarFecha:boolean = false
  manejaCajaDinamica:boolean = false
  digitaCantidadEnVenta: boolean = false
  devolverVenta: boolean = false
  creaProductoRapidoDesdeCaja: boolean = false
  manejaCodigoDeBarras: boolean = false
  cantidadImpresionesEnCaja: string = "1"
  digitaDescripcion: boolean = false
  descripcionVenta: string = ""
  creaClienteDesdeCaja: boolean = false
  estadoFormCrearCliente: boolean = false
  visualizaDetalleReciboEnCaja: boolean = false
  formaPagoSeleccionada: string = 'O'

  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  cambiarPrecioEnLosProductos: boolean = false
  refactorizarPedidosSalon: boolean = false
  companiasId
  fechaVencimiento:Date
  manejaPlanDePagosEnCuentasPorCobrar: boolean = false
  guardarPlanDePagosEnCuentasPorCobrarSimulador: boolean = false
  gestionarSimuladorCuotasExtras: any | string = ''
  public productosId:any
  showCrearProducto: boolean = false;
  tipoproducto = 'P';
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  showBuscarProducto: boolean = false;
  unidad = 'UND'
  tipoImpuesto = "I"
  productos = { "nombre": "jeans", "referencia":"102030","linea":"blanda", "cantidad": 10};
  cantidadPorDefecto: number = 10;
  tallaSeleccionada: string = null;
  colorSeleccionado: string = null;
  cantidadSeleccionada: number = null;
  colorBusqueda: string = '';
  tallas = [
    {"talla":"unica"},
    {"talla":"ya sabe"},
    {"talla":"02"},
    {"talla":"04"},
    {"talla":"06"},
    {"talla":"08"},
    {"talla":"10"},
    {"talla":"12"}
  ];
  colores = [
    {"color":"rojo"},
    {"color":"incalculable"},
    {"color":"verde"},
    {"color":"amarillo"},
    {"color":"morado"}
  ];
  combinacionesSeleccionadas = {};
  combinaciones = []; // Lista de colores filtrados
  colorExiste: boolean = false;
  coloresFiltrados: any[] = [];
  camposAdicionales = []
  tipoProducto:string = 'P'
  valoresNuevosCampos = []
  elProducto:any
  constructor(private storage: Storage,     public utils:UtilsProvider,
    public servicioProductos:ProductosProvider,  public auth: AuthService,
    public navCtrl: NavController, public push:PushProvider,
    public servicioCompania:CompaniasProvider,
    public navParams: NavParams,public viewControllers: ViewController
  ) {
    if(this.navParams.get('productosId')){
      this.productosId = this.navParams.get('productosId')
      this.nombreProducto = this.navParams.get('nombreProducto')
      this.tipoProducto = this.navParams.get('tipo')
      let general = this.navParams.get('general')
      this.elProducto = this.navParams.get('elProducto')
      if(general === 'G') {
        this.tipoProducto = 'G'
        this.valoresNuevosCampos = this.navParams.get('valoresNuevosCampos')
        this.camposAdicionales = this.valoresNuevosCampos.map((item)=>{
          return {
            valor:0, // item.valorVenta,
            nombre:item.nombreProducto,
            //valorFormatted: this.formatNumberWithThousands(item.valorVenta),
            valorFormatted: this.formatNumberWithThousands(0),
            nombreImpuesto: item.nombreImpuesto,
            valorImpuestoReal: item.valorImpuestoReal,
            productosId: item.productosId
          }
        })
      }else {
        this.buscarCamposAdicionales(this.productosId)
      }
      let cambiarPrecioEnLosProductos = this.navParams.get('cambiarPrecioEnLosProductos')
      this.listaProductosSeleccionados = this.navParams.get('data')
      this.refactorizarPedidosSalon = this.navParams.get('refactorizarPedidosSalon')
      this.valorTotalVenta = this.navParams.get('valorTotalVenta')
    }
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{

      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
        this.companiasId = val['companiasId']
      }
    })
  }

  guardarProductoRapido(){
    if(this.codigoBarra == "" || this.codigoBarra == undefined) {
      this.codigoBarra = this.codigoProducto
    }
    if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" && this.valorVenta !== 0){


    this.storage.get('companiasId').then((val) => {
    let nombretabla = "productos";
    let datosProducto: any = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        valorVenta: this.valorVenta,
        existenciasMinimas:0,
        existenciasActuales: 0,
        visualizaEnCaja: true,
        controlaEnInventario: true,
        tipoImpuesto: this.tipoImpuesto,
        valorImpuesto: this.valorImpuesto,
        centroDeCostosId: 1,
        imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
        codigoBarra:this.codigoBarra,
        companiasId:val,
        costo:this.costo,
        queHago: "I",
        nombreTabla: "productos",
        name: "dataDynamicCrud",
        unidad: this.unidad
      }

      if(this.tipoproducto === "E") {
        nombretabla = "productosElaborados";
        datosProducto = {
          companiasId: val,
          queHago: "I",
          nombreTabla: "productosElaborados",
          name: "dataDynamicCrud",
          productosElaboradosId:  "0",
          codigoProductoElaborado: this.codigoProducto,
          nombreProductoElaborado: this.nombreProducto,
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          estado: 0,
          prioridad: 0,
          codigoBarra:this.codigoBarra,
          unidad: this.unidad
        }
    }

      this.servicioProductos.guardarProducto(datosProducto,nombretabla)
      .subscribe(
        (res:any) => {
          let responseJson = JSON.parse(res['_body'])
          let response = ''
          if(responseJson !== undefined && responseJson.data !== undefined
            && responseJson.data.response !== undefined &&
            responseJson.data.response[0] !== undefined &&
            responseJson.data.response[0][0] !== undefined &&
            responseJson.data.response[0][0][''] !== undefined &&
            responseJson.data.response[0][0][''][1] !== undefined) {
              response = 'El código del producto que desea ingresar ya existe en la base de datos..'
              this.utils.mensajeMuestro('productos',response,"warning")
            } else {
              this.utils.mensajeMuestro('productos',"Producto guardado..","success")
            }
          this.limpiarProducto()

        },
        err => {
            this.utils.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
            this.limpiarProductoRapido()
        }
      )

    })
}else{
    this.utils.mensajeMuestro('productos',"No se pudo guardar el producto existen campos obligatorios","advertencia")
    this.limpiarProductoRapido()
}
}

limpiarProductoRapido(){

  this.codigoBarra =""
  this.nombreProducto = ""
  this.codigoProducto = ""
  this.valorVenta = 0
  this.costo = 0
  this.formState = 'collapsed'
  this.formStatebool = false
  this.productoId = ""
  this.cantidadRealCodigoBarra = 0
  this.unidad = "UND"
  this.tipoImpuesto = "I"
}
limpiarProducto(){

  this.codigoBarra =""
  this.nombreProducto = ""
  this.codigoProducto = ""
  this.valorVenta = 0
  this.costo = 0
  this.formState = 'collapsed'
  this.formStatebool = false
  this.productoId = ""
  this.cantidadRealCodigoBarra = 0
  this.unidad = "UND"
  this.tipoImpuesto = "I"
}
cerrarSession(){
  // this.auth.logout()
  // this.navCtrl.setRoot('LoginPage');
  this.viewControllers.dismiss([]);
}
agregarCombinacion() {
  const nuevaCombinacion = {
    talla: this.tallaSeleccionada,
    color: this.colorSeleccionado,
    cantidad: this.cantidadSeleccionada ? this.cantidadSeleccionada : this.cantidadPorDefecto
  };

  this.combinaciones.push(nuevaCombinacion);

  // Limpiar selección después de agregar
  this.tallaSeleccionada = null;
  this.colorSeleccionado = null;
  this.cantidadSeleccionada = null;
}

eliminarCombinacion(combinacion) {
  const index = this.combinaciones.indexOf(combinacion);
  if (index > -1) {
    this.combinaciones.splice(index, 1);
  }
}

guardarCombinaciones() {
  // Aquí puedes procesar las combinaciones para guardarlas
  console.log("Combinaciones guardadas:", this.combinaciones);
}

// Método para mostrar una alerta de confirmación
mostrarAlerta(titulo: string, mensaje: string) {
  this.utils.mostrarMensaje(titulo,mensaje)
}


buscarColor() {
  if (this.colorBusqueda && this.colorBusqueda.trim() !== '') {
    // Filtrar los colores que coinciden con lo que escribe el usuario
    this.coloresFiltrados = this.colores
      .filter(c => c.color.toLowerCase().includes(this.colorBusqueda.toLowerCase()));
    console.log(this.coloresFiltrados)
    // Verificar si el color ingresado ya existe en la lista completa
    this.colorExiste = this.colores
      .some(c => c.color.toLowerCase() === this.colorBusqueda.toLowerCase());
  } else {
    // Si no hay nada ingresado, limpiar los resultados
    this.coloresFiltrados = [];
    this.colorExiste = false;
  }
}

// Método para seleccionar un color de las sugerencias
seleccionarColor(color) {
  this.colorBusqueda = color.color;  // Actualizar la búsqueda con el color seleccionado
  this.coloresFiltrados = [];        // Limpiar las sugerencias
  this.colorExiste = true;           // Marcar como que el color ya existe
}

// Método para agregar un nuevo color si no existe
agregarColor() {
  const nuevoColor = { color: this.colorBusqueda };
  this.colores.push(nuevoColor);     // Agregar el nuevo color a la lista
  this.coloresFiltrados = [];        // Limpiar las sugerencias
  this.colorExiste = true;           // Marcar como que el color ya existe
  this.colorBusqueda = '';           // Limpiar el campo de búsqueda
}

async buscarCamposAdicionales(productosId:any) {
  let companiasId = await this.storage.get('companiasId')
  let data = await this.servicioProductos.buscarProductosCamposAdicionales(companiasId,productosId,'P')
  let response = data.json()

  let datosAdicionales = response.data[0]
  if(datosAdicionales.length == 0) {
    this.camposAdicionales = [
      { nombre:'',valor:0},
      { nombre:'',valor:0},
      { nombre:'',valor:0},
      { nombre:'',valor:0},
      { nombre:'',valor:0}
    ]
  } else {
    if(datosAdicionales[0].valor == "" || datosAdicionales[0].nombre == "") {
      this.camposAdicionales = [
        { nombre:'',valor:0},
        { nombre:'',valor:0},
        { nombre:'',valor:0},
        { nombre:'',valor:0},
        { nombre:'',valor:0}
      ]
    }else {
      let valores = datosAdicionales[0].valor.split(',');
      let nombres = datosAdicionales[0].nombre.split(',');

      let resultado = valores.map((val, index) => {
        return {
          valor: val,
          nombre: nombres[index],
          productosId:productosId
        };
      });
      this.camposAdicionales = resultado.map((item)=>{
        return {
          valor:item.valor,
          nombre:item.nombre,
          valorFormatted: this.formatNumberWithThousands(item.valor),
          productosId:item.productosId
        }
      })
    }
  }
}

formatValor(cuota) {
  let valorSinComas = cuota.valorFormatted.replace(/,/g, '');
  cuota.valor = Number(valorSinComas);
  cuota.valorFormatted = this.formatNumberWithThousands(cuota.valor);
}

// Función para formatear números con separadores de miles
formatNumberWithThousands(value: number): string {
  return value.toLocaleString('en-US'); // Puedes ajustar el formato regional si es necesario
}

async actualizar(data:any,item:any,index:any) {
  const companiasId = await this.storage.get('companiasId')
  let id  = Number(index)
  let nuevaValor = item.valor
  let tipoProducto  = this.tipoProducto
  let productosId = item.productosId
  let valorVentasTotalProductoNuevo = 0
  let ValorProductoVentas = 0
  let ValorSumoImpuesto = 0
  let nombreProducto = item.nombre
  let valor  = item.valorFormatted
  if(this.tipoProducto === 'G') {
    let noSePuedeGuardar = this.listaProductosSeleccionados.filter((item)=> item.productosId == this.valoresNuevosCampos[id].productosId)
    if(noSePuedeGuardar.length>0) {
      this.utils.mensajeMuestro('Producto con nombre diferente y/o precio', 'Este mensaje aparece porque ya tienes este producto agregado en la venta. Debes crear otro producto con el campo "producto rápido" para poder agregar varios con diferentes nombres y precios.', 'warning')
      return
    }
  }
  if(this.tipoProducto === "G") {
    let camposAgregar = this.valoresNuevosCampos[id]
    camposAgregar['cantidad'] = 1
    camposAgregar['nombreProducto'] = item.nombre
    camposAgregar['valorVenta'] = Number(item.valorFormatted)
    camposAgregar['valorProducto'] = Number(item.valorFormatted)
    let valor =  Number(item.valorFormatted)
    if (isNaN(valor)) {
      this.utils.mensajeMuestro('producto rapido','Debe agregar un valor',"warning")
      return
    }
    camposAgregar['valorTotalVenta'] = 0
    camposAgregar['valorImpuesto'] = item.valorImpuestoReal
    camposAgregar['valorImpuestoCalculo'] = item.valorImpuestoCalculo
    let existeProducto = this.listaProductosSeleccionados.filter((item)=> item.productosId == this.productosId &&
                            item.tipoProducto == this.tipoProducto)
    if(existeProducto.length === 0){
      productosId = camposAgregar.productosId
      this.listaProductosSeleccionados.push(camposAgregar)
    } else {
      this.listaProductosSeleccionados[id]['cantidad'] = 1
      this.listaProductosSeleccionados[id]['nombreProducto'] = item.nombre
      this.listaProductosSeleccionados[id]['valorVenta'] = Number(item.valorFormatted)
      this.listaProductosSeleccionados[id]['valorProducto'] = Number(item.valorFormatted)
      this.listaProductosSeleccionados[id]['valorTotalVenta'] = 0
      this.listaProductosSeleccionados[id]['valorImpuesto'] = item.valorImpuestoReal
      this.listaProductosSeleccionados[id]['valorImpuestoCalculo'] = item.valorImpuestoCalculo
    }
    this.actualizarProductoCambiarNombre(nombreProducto,valor,productosId)
  }

  for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
    if(this.tipoProducto !== 'G') {
    } else {


      if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == 'G'){
        valorVentasTotalProductoNuevo += Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
        this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
        let valorImpuestoCalculado = this.listaProductosSeleccionados[k].valorImpuesto
        ValorProductoVentas = Math.round(this.listaProductosSeleccionados[k].valorVenta / ((valorImpuestoCalculado / 100)+1))

        let valorVenta = this.listaProductosSeleccionados[k].valorVenta;

        let valorBase = valorVenta / ((valorImpuestoCalculado / 100) + 1);
        let ValorSumoImpuesto = valorVenta - Math.round(valorBase);
        this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
        this.listaProductosSeleccionados[k].valorProducto = ValorProductoVentas
        this.listaProductosSeleccionados[k].valorVenta = Number(this.listaProductosSeleccionados[k].valorVenta)
        this.listaProductosSeleccionados[k].valorImpuesto = ValorSumoImpuesto
        this.listaProductosSeleccionados[k].tipoProducto = 'P'
        this.listaProductosSeleccionados[k].valorImpuestoCalculo = 0
        this.refactorizarPedidosSalon = true
      }

    }
  }

  if(this.tipoProducto !== "G") {

      let existeProductoPrincipal = this.listaProductosSeleccionados.filter((item)=> item.productosId == productosId &&
      item.tipoProducto == "P")
      if(existeProductoPrincipal.length === 1 && existeProductoPrincipal[0].valorVenta === 0){
        this.listaProductosSeleccionados[0]['cantidad'] = 1
        this.listaProductosSeleccionados[0]['nombreProducto'] = item.nombre
        this.listaProductosSeleccionados[0]['valorVenta'] = Number(item.valorFormatted)
        this.listaProductosSeleccionados[0]['valorProducto'] = Number(item.valorFormatted)
        this.listaProductosSeleccionados[0]['valorTotalVenta'] = 0
        this.listaProductosSeleccionados[0]['valorImpuesto'] = this.elProducto.valorImpuesto
        this.listaProductosSeleccionados[0]['valorImpuestoCalculo'] = this.elProducto.valorImpuestoCalculo
      } else {
        let camposAgregar = {}
        camposAgregar['cantidad'] = 1
        camposAgregar['nombreProducto'] = item.nombre
        camposAgregar['valorVenta'] = Number(item.valorFormatted)
        camposAgregar['valorProducto'] = Number(item.valorFormatted)
        let valor =  Number(item.valorFormatted)
        if (isNaN(valor)) {
          this.utils.mensajeMuestro('producto rapido','Debe agregar un valor',"warning")
          return
        }
        camposAgregar['valorTotalVenta'] = 0
        camposAgregar['valorImpuesto'] = this.elProducto.valorImpuesto
        camposAgregar['valorImpuestoCalculo'] = this.elProducto.valorImpuestoCalculo
        let nuevoProducto = {
          ...this.elProducto,  // Agrega todos los valores base de this.elProducto
          ...camposAgregar     // Agrega los nuevos valores, sobreescribiendo si es necesario
        };

        this.listaProductosSeleccionados.unshift(nuevoProducto)
      }
    }
    valorVentasTotalProductoNuevo = 0
    for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
      valorVentasTotalProductoNuevo += Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
    }
    this.valorTotalVenta = valorVentasTotalProductoNuevo
    this.viewControllers.dismiss([this.listaProductosSeleccionados, {refactorizarPedidosSalon:this.refactorizarPedidosSalon,tipoProducto:this.tipoProducto}]);
}


ionViewDidLoad() {
  const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
  element.style.height = '100%';
  element.style.width = '100%';
  element.style.top = '0';
  element.style.left = '0';
  element.style.right = '0';
  element.style.bottom = '0';
}


actualizarProductoCambiarNombre(nombreProducto:any,valorVenta:any, productosId:any) {
  this.storage.get('companiasId').then((val) => {
    let nombretabla = "productos";
    let datosProducto: any = {
        nombreProducto: nombreProducto,
        productosId: productosId,
        valorVenta: valorVenta,
        queHago: "A",
        nombreTabla: "productos",
        name: "dataDynamicCrud",
      }


      this.servicioProductos.guardarProducto(datosProducto,nombretabla)
      .subscribe(
        (res:any) => {
        },
        err => {
        }
      )

    })
}
selectContent(event: any) {
  event.target.select();
}

}



// WEBPACK FOOTER //
// ./src/components/productos-campos-adicionales-cambiar-valor/productos-campos-adicionales-cambiar-valor.ts